module.exports = __webpack_public_path__ + "static/media/alertDriverLicense.47c3615e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/alertDriverLicense.svg
// module id = 866
// module chunks = 3